import { Trans } from 'react-i18next'

import { FormatPrice, refundMethods } from '@reveni-io/reveni-ui'

import InstantOPMText from './InstantOPMText/InstantOPMText'
import InstantRefundText from './InstantRefundText/InstantRefundText'
import InstantStoreCreditText from './InstantStoreCreditText/InstantStoreCreditText'

const RefundMessage = ({ refundMethod, orderAmount, storeName, refundOnHold }) => {
  if (refundOnHold || !refundMethod?.is_instant) {
    return (
      <p>
        <Trans
          i18nKey="refundProcessCompletedMessage"
          values={{ amount: orderAmount?.remaining_amount || 0, storeName }}
          defaults="Recibirás los <strong><price>{{amount}}</price></strong> de tu reembolso cuando {{storeName}} valide tu devolución."
          components={{ strong: <strong />, price: <FormatPrice currency={orderAmount?.currency || 'EUR'} /> }}
        />
      </p>
    )
  }

  return (
    <>
      {refundMethod.name === refundMethods.bankTransfer && <InstantRefundText orderAmount={orderAmount} />}
      {refundMethod.name === refundMethods.originalPaymentMethod && <InstantOPMText orderAmount={orderAmount} />}
      {refundMethod.name === refundMethods.storeCredit && <InstantStoreCreditText orderAmount={orderAmount} />}
    </>
  )
}

export default RefundMessage
